import React from 'react';
import { lengthString } from '../utils';

export default class Marker extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextProps) {
    this.text = nextProps.text || lengthString(nextProps.position);
  }

  render() {
    if (typeof this.props.position !== 'number' ||
      this.props.position < 0 ||
      this.props.position > this.props.duration) return null;

    let tooltipStyle = {};
    if (this.props.color) {
      tooltipStyle.backgroundColor = this.props.color;
    }

    const markerPosition = (this.props.position / this.props.duration) * 100;
    let style = {
      left: markerPosition + '%',
      backgroundColor: tooltipStyle.backgroundColor || undefined
    };

    if (markerPosition >= 50) {
       tooltipStyle.right = 0;
    }
    return (
      <div className='b-marker'
        style={style}
        onClick={e => this.props.onClick(e)}
      >
        <div className='b-marker-tooltip' style={tooltipStyle}>
          <span>{this.text}</span>
        </div>
      </div>
    );
  }
}
